
import { useState } from 'react';
import Logo from '../../../images/logo.png';
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
          <img src={Logo} alt="logo" className="w-12 h-12" />
            <div>
              <h1 className="text-xl font-bold text-gray-900" style={{ fontFamily: 'Pacifico, serif' }}>
                Bharat Batteries & Solar
              </h1>
              <p className="text-xs text-emerald-600 font-medium">PM Surya Ghar Yojana 2025</p>
            </div>
          </div>

          <nav className="hidden md:flex items-center space-x-8">
            <a href="#home" className="text-gray-700 hover:text-emerald-600 font-medium transition-colors cursor-pointer">
              Home
            </a>
            <a href="#plans" className="text-gray-700 hover:text-emerald-600 font-medium transition-colors cursor-pointer">
              Solar Plans
            </a>
            <a href="#benefits" className="text-gray-700 hover:text-emerald-600 font-medium transition-colors cursor-pointer">
              Benefits
            </a>
            <a href="#contact" className="text-gray-700 hover:text-emerald-600 font-medium transition-colors cursor-pointer">
              Contact
            </a>
            <a 
              href="tel:7496038344" 
              className="bg-emerald-600 text-white px-6 py-2 rounded-full hover:bg-emerald-700 transition-colors font-medium whitespace-nowrap cursor-pointer"
            >
              Call Now
            </a>
          </nav>

          <button 
            className="md:hidden p-2 text-gray-600 hover:text-emerald-600 cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-100">
            <nav className="flex flex-col space-y-3 pt-4">
              <a href="#home" className="text-gray-700 hover:text-emerald-600 font-medium transition-colors cursor-pointer">
                Home
              </a>
              <a href="#plans" className="text-gray-700 hover:text-emerald-600 font-medium transition-colors cursor-pointer">
                Solar Plans
              </a>
              <a href="#benefits" className="text-gray-700 hover:text-emerald-600 font-medium transition-colors cursor-pointer">
                Benefits
              </a>
              <a href="#contact" className="text-gray-700 hover:text-emerald-600 font-medium transition-colors cursor-pointer">
                Contact
              </a>
              <a 
                href="tel:7496038344" 
                className="bg-emerald-600 text-white px-6 py-2 rounded-full hover:bg-emerald-700 transition-colors font-medium text-center whitespace-nowrap cursor-pointer"
              >
                Call Now
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
